import { getCertificates } from '@/api/cvs'
import { resumeTemplate, resumeChildrenTemplate } from '@/views/resumeBuilder/sampleData'

const resume = {
  state: {
    certificates: [],
    resumeList: [],
    resumeTemplate,
    resumeChildrenTemplate
  },
  getters: {
    getCertificates: state => state.certificates,
    getResumeList: state => state.resumeList,
    getResumeTemplate: state => state.resumeTemplate,
    getResumeChildrenTemplate: state => state.resumeChildrenTemplate
  },
  mutations: {
    SET_CERTIFICATES: (state, certificates) => {
      state.certificates = certificates
    }
  },

  actions: {
    fetchCertificates({ commit }) {
      return new Promise((resolve, reject) => {
        getCertificates()
          .then((results) => {
            commit('SET_CERTIFICATES', results)
          })
          .catch((err) => {
            console.log('[Error]: ', err)
          })
      })
    }
  }
}

export default resume



// WEBPACK FOOTER //
// ./src/store/modules/resume.js